import React from "react";
import { DatePicker } from "antd";
import "dayjs/locale/ko";
import locale from "antd/es/date-picker/locale/ko_KR";

const { RangePicker } = DatePicker;

/**
 * 표준 리스트 페이지 필터용 날짜 범위 선택 (플랫 UI: h-7, text-xs)
 */
const InputRangeDate = (props) => {
    const handleInput = (e) => {
        props.setValue(e);
    };

    return (
        <div className="flex flex-row gap-2 items-center">
            {props.title ? (
                <span className="text-xs text-gray-600 text-nowrap">{props.title}</span>
            ) : null}
            <RangePicker
                size="small"
                className="input-range-date-standard"
                separator="~"
                placeholder={["시작", "종료"]}
                locale={locale}
                value={[props.startTime, props.endTime]}
                onChange={handleInput}
            />
        </div>
    );
};

export default InputRangeDate;